import React, { useEffect, useState } from "react";
import Ratings from "../Ratings";
import { AiFillHeart, AiOutlineShoppingCart } from "react-icons/ai";
import { FaEye } from "react-icons/fa";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import {
  get_wishlist_products,
  remove_wishlist,
  messageClear,
} from "../../store/reducers/cardReducer";
import toast from "react-hot-toast";
import { Heart } from "lucide-react";
import { formatCurrency } from "../../utils/currencyUtils";
import { useCurrency } from "../../hooks/useCurrency"

const Wishlist = () => {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state) => state.auth);
  const { currencyCode, exchangeLoaded } = useCurrency()
  const { wishlist, successMessage } = useSelector((state) => state.card);
  useEffect(() => {
    dispatch(get_wishlist_products(userInfo.id));
  }, []);

  useEffect(() => {
    if (successMessage) {
      toast.success(successMessage);
      dispatch(messageClear());
    }
  }, [successMessage]);

  if (wishlist.length === 0) {
    return (
      <div className="w-full h-[400px] flex items-center justify-center">
        <div className="text-center text-gray-400">
          <p>No items in your wishlist</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full grid grid-cols-3 md-lg:grid-cols-2 md:grid-cols-2 sm:grid-cols-1 gap-6">
      {wishlist.map((p, i) => (
        <div
          key={i}
          className="bg-white border border-gray-100 group transition-all duration-500 hover:shadow-md cursor-pointer"
        >
          <div className="relative overflow-hidden">
            {p.discount !== 0 && (
              <div className="flex justify-center items-center absolute text-white py-[2px] px-6 rounded-full bg-red-600 font-semibold text-s left-2 top-2">
                {p.discount}%      
              </div>
            )}
            <Link to={`/product/details/${p.productId}`} className="">
              <img
                className="sm:w-full w-full h-[240px] nex_img_cover"
                src={p.image}
                alt="product"
              />
            </Link>
            <ul className="flex transition-all duration-700 -bottom-10 justify-center items-center gap-2 absolute w-full group-hover:bottom-3">
            </ul>
          </div>
          <div className="py-3 text-gray-900 px-2">
          
            <div className="flex justify-between items-center gap-3 p-2">
              <h2>{p.name}</h2> 
              <span className="text-lg font-bold"> {formatCurrency(p.price, currencyCode, exchangeLoaded)}</span>  
            </div>
            <div className="gap-3 p-2">
              <div className="flex items-center justify-between mb-4">
                <div className="flex">
                  <Ratings ratings={p.rating} />
                </div>
                <Heart
                  onClick={() => dispatch(remove_wishlist(p._id))}
                  size={24}
                />
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Wishlist;